import { Box, Button } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import PopoverComponent from "../../components/PopoverComponent";
import LinkIcon from "@mui/icons-material/Link";
import SkeltonProgress from "../../components/SkeltonProgress";
import { IService } from "src/interface/IService";
import NewSystemWeb from "./new-system-web";
import renderCellExpand from "src/GridComponents/GridExpand";
const SystemWeb = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["SystemsData"],
    queryFn: () =>
      fetch(API_URL + "systems", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = useState<any>();
  const [openTask, setOpenTask] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "نام سامانه",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 210,
    },
    {
      field: "priorityShow",
      headerName: "اولویت",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      type: "number",
      minWidth: 120,
    },
    {
      field: "url",
      headerName: "لینک سامانه",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      minWidth: 120,
      renderCell: renderCellExpand,
    },

    {
      field: "createdOn",
      headerName: "تاریخ ایجاد",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
    {
      field: "modifiedOn",
      headerName: "تاریخ ویرایش",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="برو به سامانه">
            <GridActionsCellItem
              icon={<LinkIcon color="primary" />}
              label="برو به سامانه"
              className="textPrimary"
              onClick={() => window.open(params.row.url, "_blank")}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
  ];

  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "systems/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "systems/" + bankId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [bankId, setBankId] = useState("");

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setBankId(id);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenTask(true)}
        >
          سامانه جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };
  const handleClose = () => {
    setOpenTask(false);
  };
  return (
    <>
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewSystemWeb
        open={openTask}
        handleClose={handleClose}
        refetch={refetch}
        // data={rowInfo}
      />

      <Box>
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            gridUniqueName="Systems"
            columns={columns}
            loading={isLoading || isEditLoading}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            processRowUpdate={processRowUpdate}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            rows={rows}
            setRowModesModel={setRowModesModel}
          />
        )}
      </Box>
    </>
  );
};

export default SystemWeb;
